import React, { useState } from 'react'
import CertInHTMLReport from '../../../Pages/CertInHTMLReport'
import { AlignmentType, BorderStyle, Document, Footer, Header, HeadingLevel, ImageRun, LevelFormat, NumberFormat, Packer, PageNumber, PageOrientation, Paragraph, SectionType, ShadingType, TabStopType, Table, TableCell, TableLayoutType, TableOfContents, TableRow, TextRun, VerticalAlign, WidthType, convertInchesToTwip } from 'docx'
import { saveAs } from 'file-saver'
import { certinDesign, fontPageBlueImage, reportAppDate, reportAppName } from '../CertInSupport-Page/Part1CertIn/FrontPage'
import homepageImage from '../../../../Assests/ReportImages/isecurion1.png';
import { documentFirstTable, documentHeading, documentHeading2, documentSecondTable } from '../CertInSupport-Page/Part1CertIn/Page1'
import { page2Heading, page2Heading2, page2firstTable, page2secondTable } from '../CertInSupport-Page/Part1CertIn/Page2'
import { aboutHeading, aboutPage1, aboutPage2, aboutPage3, aboutPage4, bulletOne, bulletThree, bulletTwo, bulletfive, bulletfour, bulletsix } from '../CertInSupport-Page/Part1CertIn/Page4'
import { TOCHeadings } from '../CertInSupport-Page/Part1CertIn/Page3'
import { disclaimerHeading, disclaimerPage1, disclaimerPage2, disclaimerPage3, disclaimerPage4, disclaimerPage5 } from '../CertInSupport-Page/Part1CertIn/Page5'
import { objectiveBulletOne, objectiveBulletThree, objectiveBulletTwo, objectiveHeading, objectivePage1, overviewHeading, overviewPage1, scope1, scopeHeading, scopeTable } from '../CertInSupport-Page/Part1CertIn/Page6'
import { SummaryNote, SummaryRecommendation, noteUserRoles, recommendationBulletOne, recommendationBulletTwo, sumaryNote1, summaryBulletOne, summaryHeading, summeryPage } from '../CertInSupport-Page/Part2CertIn/Page7'
import { acclimatizePhase, acclimatizePhaseText, accrualPhase, accrualPhaseText, accrualPhasebullet1, accrualPhasebullet2, accrualPhasebullet3, methodologyHeading, setUpAndMethodology } from '../CertInSupport-Page/Part2CertIn/Page8'
import { admittancePhase, admittancePhaseText, affirmationPhase, affirmationPhaseText, analysisPhase, analysisPhaseText } from '../CertInSupport-Page/Part2CertIn/Page9'
import { areaCovered, areaCoveredText, coveredPoint1, coveredPoint2, coveredPoint3, coveredPoint4, coveredPoint5, coveredPoint6, coveredPoint7, coveredPoint9, framework, frameworkHeading, frameworkText, tools, toolsTable, coveredPoint10 } from '../CertInSupport-Page/Part2CertIn/Page10'
// import { coveredPoint10 } from '../BlueFormatSupport-Page/Part2/Page9/Page9-Support'
import { OWASPHeading, OWASPText1, OWASPText2, barchartText, owasptableText, top10ListTable } from '../CertInSupport-Page/Part2CertIn/Page11'
import { exploitationTable, graphText, mappingTable, observationHeading, observationText1, observationText2, piechartText, severityLevelTable, severityTable, severityText, tableText } from '../CertInSupport-Page/Part2CertIn/Page12'
import { findingsHeading, findingsTable, findingsText1 } from '../CertInSupport-Page/Part2CertIn/Page13'
import { stageHeading, stageText1, stageText2, stageText3 } from '../CertInSupport-Page/Part3CertIn/Page14'
import { verificationHeading, verificationTable } from '../CertInSupport-Page/Part3CertIn/Page16'
import { conclusionHeading, conclusionText1, conclusionText10, conclusionText11, conclusionText2, conclusionText3, conclusionText4, conclusionText5, conclusionText6, conclusionText7, conclusionText8, conclusionText9 } from '../CertInSupport-Page/Part3CertIn/Page17'
import { useAuth } from '../../../../Context/UserContext'
import { handleCertInAuditDownload } from '../CertInAuditSupport-Page/CertInAuditReport'
import { useToast } from 'react-toastify'
import { confidentialMaterial1Certin, confidentialMaterial2Certin, confidentialMaterial3Certin, confidentialMaterial4Certin } from './Part1CertIn/confidential'


function CertInReport() {

    const { emailVer, logout, userRole: userRoles } = useAuth()

    const [certInReportName, setCertInReportName] = useState('')
    const [certInDate, setCertInDate] = useState('')
    const [certInCustomerName, setCertInCustomerName] = useState('')
    const [certInLogo, setCertInLogo] = useState('')
    const [certInApplicationName, setCertInApplicationName] = useState('')
    const [certInApplicationUrl, setCertInApplicationUrl] = useState('')
    const [certInStartDate, setCertInStartDate] = useState('')
    const [certInEndDate, setCertInEndDate] = useState('')
    const [certInTestingype, setCertInTestingType] = useState('')
    const [certInAppDescription, setCertInAppDescription] = useState('')
    const [certInAppEnvironment, setCertInAppEnvironment] = useState('')
    const [certInRoles, setCertInRoles] = useState('')
    const [criticality, setCriticality] = useState('')

    const [imageUrl, setImageUrl] = useState(null);

    const [inchargeName, setInchargeName] = useState('')
    const [inchargeEmail, setInchargeEmail] = useState('')
    const [inchargeDesignation, setInchargeDesignation] = useState('')

    const [certInVulCount, setCertInVulCount] = useState('')
    const [certInCritical, setCertInCritical] = useState('')
    const [certInHigh, setCertInHigh] = useState('')
    const [certInMedium, setCertInMedium] = useState('')
    const [certInLow, setCertInLow] = useState('')
    const [certInInfo, setCertInInfo] = useState('')
    const [certInA1, setCertInA1] = useState('')
    const [certInA2, setCertInA2] = useState('')
    const [certInA3, setCertInA3] = useState('')
    const [certInA4, setCertInA4] = useState('')
    const [certInA5, setCertInA5] = useState('')
    const [certInA6, setCertInA6] = useState('')
    const [certInA7, setCertInA7] = useState('')
    const [certInA8, setCertInA8] = useState('')
    const [certInA9, setCertInA9] = useState('')
    const [certInA10, setCertInA10] = useState('')

    const [certInReportNameError, setCertInReportNameError] = useState('')
    const [certInDateError, setCertInDateError] = useState('')
    const [certInCustomerNameError, setCertInCustomerNameError] = useState('')
    const [certInLogoError, setCertInLogoError] = useState('')
    const [certInApplicationNameError, setCertInApplicationNameError] = useState('')
    const [certInApplicationUrlError, setCertInApplicationUrlError] = useState('')
    const [certInStartDateError, setCertInStartDateError] = useState('')
    const [certInEndDateError, setCertInEndDateError] = useState('')
    const [certInTestingypeError, setCertInTestingTypeError] = useState('')
    const [certInAppDescriptionError, setCertInAppDescriptionError] = useState('')
    const [certInAppEnvironmentError, setCertInAppEnvironmentError] = useState('')
    const [certInRolesError, setCertInRolesError] = useState('')

    const [inchargeNameError, setInchargeNameError] = useState('')
    const [inchargeEmailError, setInchargeEmailError] = useState('')
    const [inchargeDesignationError, setInchargeDesignationError] = useState('')
    const [certInVulCountError, setCertInVulCountError] = useState('')
    const [certInCriticalError, setCertInCriticalError] = useState('')
    const [certInHighError, setCertInHighError] = useState('')
    const [certInMediumError, setCertInMediumError] = useState('')
    const [certInLowError, setCertInLowError] = useState('')
    const [certInInfoError, setCertInInfoError] = useState('')
    const [certInA1Error, setCertInA1Error] = useState('')
    const [certInA2Error, setCertInA2Error] = useState('')
    const [certInA3Error, setCertInA3Error] = useState('')
    const [certInA4Error, setCertInA4Error] = useState('')
    const [certInA5Error, setCertInA5Error] = useState('')
    const [certInA6Error, setCertInA6Error] = useState('')
    const [certInA7Error, setCertInA7Error] = useState('')
    const [certInA8Error, setCertInA8Error] = useState('')
    const [certInA9Error, setCertInA9Error] = useState('')
    const [certInA10Error, setCertInA10Error] = useState('')

    const [certInDownloading, setCertInDownloading] = useState(false)

    const [certInVulnerabilities, setCertInVulnerabilities] = useState([
        { vulnerability: '', description: '', category: '', uRLAddress: '', impact: '', risk: '', recommendation: '', reference: '', cvss: '', exploitation: '', poc: [{ pocDesc: '', files: [] }] }
    ])

    const handleCertInDownload = () => {
        handleCertInPhase1Download()
        handleCertInAuditDownload({
            certInReportName, certInApplicationName, certInDate, certInStartDate, certInEndDate,
            inchargeDesignation, inchargeEmail, inchargeName, certInCustomerName,
            criticality, certInApplicationUrl, certInAppDescription,
            certInAppEnvironment, certInTestingype, certInRoles,
            certInCritical, certInHigh, certInMedium, certInLow, certInInfo, certInVulnerabilities,
            certInDownloading, setCertInDownloading, logout
        })
    }

    const handleCertInPhase1Download = async () => {

        const frontPage1 = certinDesign
        const frontPage2 = fontPageBlueImage
        const frontPage3 = reportAppName(certInApplicationName)
        const frontPage4 = reportAppDate(certInDate)

        const page11c = confidentialMaterial1Certin
        const page12c = confidentialMaterial2Certin
        const page13c = confidentialMaterial3Certin(certInCustomerName)
        const page14c = confidentialMaterial4Certin(certInCustomerName)

        const page11 = documentHeading
        const page12 = documentFirstTable(certInApplicationName)
        const page13 = documentHeading2
        const page14 = documentSecondTable(certInCustomerName, certInDate)

        const page21 = page2Heading
        const page22 = page2firstTable(certInDate)
        const page23 = page2Heading2
        const page24 = page2secondTable

        const page31 = TOCHeadings

        const page42 = aboutPage1
        const page43 = aboutPage2
        const page44 = aboutPage3
        const page45 = aboutPage4
        const page451 = bulletOne
        const page452 = bulletTwo
        const page453 = bulletThree
        const page454 = bulletfour
        const page455 = bulletfive
        const page456 = bulletsix

        const page52 = disclaimerPage1(certInCustomerName)
        const page53 = disclaimerPage2
        const page54 = disclaimerPage3(certInCustomerName)
        const page55 = disclaimerPage4
        const page56 = disclaimerPage5

        const page611 = overviewPage1(certInAppDescription)
        const page621 = objectivePage1(certInApplicationName)
        const page622 = objectiveBulletOne(certInApplicationName)
        const page623 = objectiveBulletTwo
        const page624 = objectiveBulletThree
        const page63 = scopeHeading
        const page631 = scope1(certInCustomerName)
        const page64 = scopeTable(certInApplicationName, certInApplicationUrl)

        const page711 = summeryPage(certInCustomerName, certInApplicationName)
        const page712 = summaryBulletOne(certInEndDate, certInStartDate)
        const page72 = SummaryNote
        const page722 = noteUserRoles(certInTestingype != "Black box testing methodology (Unauthenticated Testing)" ? certInRoles : '')
        const page73 = SummaryRecommendation
        const page731 = recommendationBulletOne
        const page732 = recommendationBulletTwo

        const page811 = setUpAndMethodology
        const page82 = accrualPhase
        const page821 = accrualPhaseText
        const page822 = accrualPhasebullet1
        const page823 = accrualPhasebullet2
        const page824 = accrualPhasebullet3
        const page83 = acclimatizePhase
        const page831 = acclimatizePhaseText

        const page91 = analysisPhase
        const page911 = analysisPhaseText
        const page92 = admittancePhase
        const page921 = admittancePhaseText
        const page93 = affirmationPhase
        const page931 = affirmationPhaseText

        const page102 = framework
        const page1021 = frameworkText(certInApplicationName, certInCustomerName)
        const page103 = tools
        const page1031 = toolsTable
        const page104 = areaCovered
        const page1041 = areaCoveredText
        const page1042 = coveredPoint1
        const page1043 = coveredPoint2
        const page1044 = coveredPoint3
        const page1045 = coveredPoint4
        const page1046 = coveredPoint5
        const page1047 = coveredPoint6
        const page1048 = coveredPoint7
        const page1049 = coveredPoint9
        const page10410 = coveredPoint10

        const page112 = barchartText
        const page113 = OWASPText1
        const page114 = OWASPText2

        const page115 = owasptableText
        const page116 = top10ListTable(certInA1, certInA2, certInA3, certInA4, certInA5, certInA6, certInA7, certInA8, certInA9, certInA10)

        const page1211 = observationText1(certInApplicationName, certInVulCount)
        const page1212 = observationText2
        const page1213 = mappingTable
        const page122 = severityText
        const page1221 = severityTable
        const page1222 = exploitationTable
        const page123 = graphText
        const page1231 = severityLevelTable(certInCritical, certInHigh, certInMedium, certInLow, certInInfo)
        const page1232 = tableText
        const page1241 = piechartText

        const page1312 = findingsText1

        const page1411 = stageText1
        const page1412 = stageText2
        const page1413 = stageText3

        const page162 = verificationTable

        const page1711 = conclusionText1(certInApplicationName)
        const page1712 = conclusionText2
        const page1713 = conclusionText3
        const page1714 = conclusionText4
        const page1715 = conclusionText5
        const page1716 = conclusionText6
        const page1717 = conclusionText7
        const page1718 = conclusionText8
        const page1719 = conclusionText9
        const page17110 = conclusionText10
        const page17111 = conclusionText11(certInDate)

        const imageData = await fetch(homepageImage).then(response => response.blob());

        const footerIsecurion = new ImageRun({
            type: 'png',
            data: await imageData.arrayBuffer(),
            transformation: {
                width: 225,
                height: 60
            },
        });

        const design = {
            page: {
                margin: { header: 350, footer: 700 },
                size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
                type: SectionType.CONTINUOUS,
            },
        }

        const page41 = new Paragraph({
            alignment: AlignmentType.LEFT,
            spacing: { before: 150, after: 250, },
            indent: { left: 400 },
            numbering: { reference: "my-crazy-numbering", level: 0 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "About ISECURION",
                    size: 26,
                    color: "C00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })

        const page51 = new Paragraph({
            alignment: AlignmentType.LEFT,
            spacing: { before: 150, after: 250, },
            indent: { left: 400 },
            numbering: { reference: "my-crazy-numbering", level: 0 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "Disclaimer",
                    size: 26,
                    color: "C00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })

        const page61 = new Paragraph({
            alignment: AlignmentType.LEFT,
            spacing: { before: 150, after: 250, },
            indent: { left: 400 },
            numbering: { reference: "my-crazy-numbering", level: 0 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "Application Overview",
                    size: 26,
                    color: "C00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })

        const page62 = new Paragraph({
            alignment: AlignmentType.LEFT,
            spacing: { before: 150, after: 250, },
            indent: { left: 400 },
            numbering: { reference: "my-crazy-numbering", level: 0 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "Objectives and Scope",
                    size: 26,
                    color: "C00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })

        const page71 = new Paragraph({
            alignment: AlignmentType.LEFT,
            spacing: { before: 150, after: 250, },
            indent: { left: 400 },
            numbering: { reference: "my-crazy-numbering", level: 0 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "Executive Summary",
                    size: 26,
                    color: "C00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })

        const page81 = new Paragraph({
            alignment: AlignmentType.LEFT,
            spacing: { before: 150, after: 250, },
            indent: { left: 400 },
            numbering: { reference: "my-crazy-numbering", level: 0 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "Methodology",
                    size: 26,
                    color: "C00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })

        const page101 = new Paragraph({
            alignment: AlignmentType.LEFT,
            spacing: { before: 150, after: 250, },
            indent: { left: 400 },
            numbering: { reference: "my-crazy-numbering", level: 0 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "Framework and tools used for Audit",
                    size: 26,
                    color: "C00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })

        const page111 = new Paragraph({
            alignment: AlignmentType.LEFT,
            spacing: { before: 150, after: 250, },
            indent: { left: 400 },
            numbering: { reference: "my-crazy-numbering", level: 0 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "Benchmarking with OWASP TOP 10",
                    size: 26,
                    color: "C00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })

        const page121 = new Paragraph({
            alignment: AlignmentType.LEFT,
            spacing: { before: 150, after: 250, },
            indent: { left: 400 },
            numbering: { reference: "my-crazy-numbering", level: 0 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "Observation Summary",
                    size: 26,
                    color: "C00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })

        const page131 = new Paragraph({
            alignment: AlignmentType.LEFT,
            spacing: { before: 150, after: 250, },
            indent: { left: 400 },
            numbering: { reference: "my-crazy-numbering", level: 0 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "Overview of Findings",
                    size: 26,
                    color: "C00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })

        const page141 = new Paragraph({
            alignment: AlignmentType.LEFT,
            spacing: { before: 150, after: 250, },
            indent: { left: 400 },
            numbering: { reference: "my-crazy-numbering", level: 0 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "Detailed Stage 1 Findings and Recommendations",
                    size: 26,
                    color: "C00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })

        const page161 = new Paragraph({
            alignment: AlignmentType.LEFT,
            spacing: { before: 150, after: 250, },
            indent: { left: 400 },
            numbering: { reference: "my-crazy-numbering", level: 0 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "Methods of verification to compliance with CERT-In Directions",
                    size: 26,
                    color: "C00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })

        const page171 = new Paragraph({
            alignment: AlignmentType.LEFT,
            spacing: { before: 150, after: 250, },
            indent: { left: 400 },
            numbering: { reference: "my-crazy-numbering", level: 0 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "Conclusion",
                    size: 26,
                    color: "C00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })


        const cvssMapping = new Paragraph({
            spacing: { before: 350, after: 500 },
            indent: { left: 600 },
            numbering: { reference: "my-crazy-numbering", level: 1 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "CVSS 3.1 MAPPING",
                    size: 26,
                    color: "c00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })

        const easeOfExploitation = new Paragraph({
            spacing: { before: 350, after: 500 },
            indent: { left: 600 },
            numbering: { reference: "my-crazy-numbering", level: 1 },
            tabStops: [{ type: TabStopType.LEFT, position: -1000 }],
            children: [
                new TextRun({
                    text: "Ease of Exploitation",
                    size: 26,
                    color: "c00000",
                    font: "Cambria",
                    bold: true,
                    italics: false,
                    allCaps: false
                })
            ],
            heading: HeadingLevel.HEADING_1,
        })


        // Vulnerability table code

        let clientImageRun;
        const getBase64 = (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = (error) => reject(error);
            });
        };

        const createImageRun = async (file) => {
            try {
                const imageData = await getBase64(file);
                return new ImageRun({
                    data: imageData,
                    transformation: { width: 624, height: 300 },
                });
            } catch (error) {
                console.error('Error reading image data:', error);
                return null;
            }
        };

        const fetchImageAsBase64 = async (url) => {
            const response = await fetch(url, { mode: 'cors' });
            const blob = await response.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        };

        // OverView of findings
        const rows = [
            new TableRow({
                children: [
                    new TableCell({
                        width: { size: 6, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                indent: { left: 30, right: 30 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Sl. No",
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                        indent: { left: 600 },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),
                    new TableCell({
                        width: { size: 27, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Name of Vulnerability",
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),
                    new TableCell({
                        width: { size: 13, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Severity",
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    }),
                    new TableCell({
                        width: { size: 54, type: WidthType.PERCENTAGE },
                        children: [
                            new Paragraph({
                                spacing: { before: 100, after: 100 },
                                alignment: AlignmentType.CENTER,
                                children: [
                                    new TextRun({
                                        text: "Recommendations",
                                        font: "Calibri",
                                        size: 22,
                                        color: "000000",
                                        bold: true,
                                        italics: false
                                    })
                                ]
                            })
                        ],
                        shading: { type: ShadingType.SOLID, color: "d9d9d9" },
                        borders: {
                            top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                            right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                        }
                    })
                ],
            }),
        ];

        const sortVulnerabilities = certInVulnerabilities.sort((a, b) => b.risk - a.risk);

        sortVulnerabilities.forEach((vulnerability, index) => {
            function getSeverityAndColor(riskScore) {
                let severity = "";

                if (riskScore >= 9.0 && riskScore <= 10.0) {
                    severity = "Critical";
                } else if (riskScore >= 7.0 && riskScore <= 8.9) {
                    severity = "High";
                } else if (riskScore >= 4.0 && riskScore <= 6.9) {
                    severity = "Medium";
                } else if (riskScore >= 0.1 && riskScore <= 3.9) {
                    severity = "Low";
                } else {
                    severity = "Info";
                }
                return { severity };
            }

            const riskScore = vulnerability.risk;
            const { severity } = getSeverityAndColor(riskScore);

            rows.push(
                new TableRow({
                    children: [
                        new TableCell({
                            width: { size: 5, type: WidthType.PERCENTAGE },
                            alignment: AlignmentType.CENTER,
                            verticalAlign: VerticalAlign.CENTER,
                            children: [
                                new Paragraph({
                                    spacing: { before: 200, after: 200 },
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                        new TextRun({
                                            text: `${index + 1}.`,
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                    ]
                                })
                            ],
                            shading: { type: ShadingType.SOLID, color: "ffffff" },
                            indent: { left: 600 },
                            borders: {
                                top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                            }
                        }),
                        new TableCell({
                            width: { size: 28, type: WidthType.PERCENTAGE },
                            alignment: AlignmentType.CENTER,
                            verticalAlign: VerticalAlign.CENTER,
                            children: [
                                new Paragraph({
                                    indent: { left: 60 },
                                    spacing: { before: 200, after: 200 },
                                    alignment: AlignmentType.LEFT,
                                    children: [
                                        new TextRun({
                                            text: vulnerability.vulnerability,
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                    ]
                                })
                            ],
                            shading: { type: ShadingType.SOLID, color: "ffffff" },
                            borders: {
                                top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                            }
                        }),
                        new TableCell({
                            width: { size: 14, type: WidthType.PERCENTAGE },
                            alignment: AlignmentType.CENTER,
                            verticalAlign: VerticalAlign.CENTER,
                            children: [
                                new Paragraph({
                                    spacing: { before: 200, after: 200 },
                                    alignment: AlignmentType.CENTER,
                                    children: [
                                        new TextRun({
                                            text: severity,
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                    ]
                                })
                            ],
                            borders: {
                                top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                            }
                        }),

                        new TableCell({
                            width: { size: 53, type: WidthType.PERCENTAGE },
                            verticalAlign: VerticalAlign.CENTER,
                            children: [
                                ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                    new Paragraph({
                                        indent: { left: 500, right: 50 },
                                        spacing: { before: 50, after: 50 },
                                        bullet: { level: 0 },
                                        alignment: AlignmentType.LEFT,
                                        children: [
                                            new TextRun({
                                                text: bulletText.trim(),
                                                font: "Calibri",
                                                size: 22,
                                                color: "000000",
                                                italics: false
                                            })
                                        ]
                                    })
                                )

                            ],
                            shading: { type: ShadingType.SOLID, color: "ffffff" },
                            borders: {
                                top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                            }
                        })

                    ],
                })
            );
        });

        // Vulnerability Table
        const sortedVulnerabilities = certInVulnerabilities.sort((a, b) => b.risk - a.risk);
        const docSections = sortedVulnerabilities.map(async (vulnerability, index) => {
            const combinedContent = [];
            for (const poc of vulnerability.poc) {
                combinedContent.push(new Paragraph({
                    children: [
                        new TextRun({
                            text: poc.pocDesc,
                            size: 24,
                            italics: false
                        }),
                    ],
                }));

                if (poc.files && poc.files.length > 0) {
                    for (const file of poc.files) {
                        try {
                            const imageRun = await createImageRun(file);
                            combinedContent.push(new Paragraph({
                                spacing: { before: 200, after: 300 },
                                children: [imageRun],
                            }));
                        } catch (error) {
                            console.error('Error while uploading POC image:', error);
                        }
                    }

                } else if (poc.pocImageURL) {
                    try {
                        const pocImageData = await fetchImageAsBase64(poc.pocImageURL);
                        const imageRun = new ImageRun({
                            data: pocImageData.split(',')[1],
                            transformation: { width: 624, height: 300 }
                        });
                        combinedContent.push(new Paragraph({
                            spacing: { before: 200, after: 600 },
                            children: [imageRun],
                        }));
                    } catch (error) {
                        console.error('Error while fetching PoC image from URL:', error);
                    }
                }
            }

            function getSeverityAndColor(riskScore) {
                let severity = "";
                let color = "";

                if (riskScore >= 9.0 && riskScore <= 10.0) {
                    severity = "Critical";
                    color = "c00000";
                } else if (riskScore >= 7.0 && riskScore <= 8.9) {
                    severity = "High";
                    color = "ff0000";
                } else if (riskScore >= 4.0 && riskScore <= 6.9) {
                    severity = "Medium";
                    color = "ffc000";
                } else if (riskScore >= 0.1 && riskScore <= 3.9) {
                    severity = "Low";
                    color = "ffff00";
                } else {
                    severity = "Information";
                    color = "00b050";
                }

                return { severity, color };
            }

            const riskScore = vulnerability.risk;
            const { severity, color } = getSeverityAndColor(riskScore);

            return [
                new Paragraph({
                    pageBreakBefore: true,
                    heading: HeadingLevel.HEADING_1,
                    spacing: { before: 150, after: 200 },
                    indent: { left: 600 },
                    width: { size: 100, type: WidthType.PERCENTAGE },
                    numbering: { reference: "my-crazy-numbering", level: 2 },
                    children: [
                        new TextRun({
                            text: vulnerability.vulnerability,
                            size: 24,
                            color: "000000",
                            font: "Calibri",
                            bold: true,
                            italics: false
                        })
                    ],
                }),
                new Table({
                    width: { size: 106, type: WidthType.PERCENTAGE },
                    alignment: AlignmentType.LEFT,
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                    },
                    layout: TableLayoutType.FIXED,
                    rows: [
                        new TableRow({
                            children: [
                                new TableCell({
                                    width: { size: 2035, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [
                                        new Paragraph({
                                            spacing: { before: 100, after: 100 },

                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100 },
                                            children: [new TextRun({
                                                text: "Vulnerability",
                                                font: "Calibri",
                                                size: 22,
                                                color: "ffffff",
                                                bold: true,
                                                italics: false
                                            })
                                            ]
                                        })
                                    ],
                                    shading: { type: ShadingType.SOLID, color: "003366" },
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                                new TableCell({
                                    width: { size: 8000, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [
                                        new Paragraph({
                                            spacing: { before: 100, after: 100 },
                                            indent: { left: 100, right: 80 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100 },
                                            children: [new TextRun({
                                                text: vulnerability.vulnerability,
                                                font: "Calibri",
                                                size: 22,
                                                color: "000000",
                                                italics: false
                                            })
                                            ]
                                        })
                                    ],

                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                            ]
                        }),

                        new TableRow({
                            children: [
                                new TableCell({
                                    width: { size: 2035, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [
                                        new Paragraph({
                                            spacing: { before: 100, after: 100 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100 },
                                            children: [new TextRun({
                                                text: "Description",
                                                font: "Calibri",
                                                size: 22,
                                                color: "ffffff",
                                                bold: true,
                                                italics: false
                                            })
                                            ]
                                        })
                                    ],
                                    shading: { type: ShadingType.SOLID, color: "003366" },
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                                new TableCell({
                                    width: { size: 8000, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.JUSTIFIED,
                                        indent: { left: 100, right: 80 },
                                        children: [new TextRun({
                                            text: vulnerability.description,
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                        ]
                                    })
                                    ],

                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                            ]
                        }),

                        new TableRow({
                            children: [
                                new TableCell({
                                    width: { size: 2035, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [
                                        new Paragraph({
                                            spacing: { before: 100, after: 100 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100 },
                                            children: [new TextRun({
                                                text: "OWASP Category ",
                                                font: "Calibri",
                                                size: 22,
                                                color: "ffffff",
                                                bold: true.valueOf,
                                                italics: false
                                            })
                                            ]
                                        })
                                    ],
                                    shading: { type: ShadingType.SOLID, color: "003366" },
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                                new TableCell({
                                    width: { size: 8000, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        indent: { left: 100, right: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.category,
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                        ]
                                    })
                                    ],

                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                            ]
                        }),

                        new TableRow({
                            children: [
                                new TableCell({
                                    width: { size: 2035, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [
                                        new Paragraph({
                                            spacing: { before: 100, after: 100 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100 },
                                            children: [new TextRun({
                                                text: "Affected URL Address ",
                                                font: "Calibri",
                                                size: 22,
                                                color: "ffffff",
                                                bold: true,
                                                italics: false
                                            })
                                            ]
                                        })
                                    ],
                                    shading: { type: ShadingType.SOLID, color: "003366" },
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                                new TableCell({
                                    width: { size: 8000, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: vulnerability.uRLAddress.split(/\s+/).map((url) =>
                                        new Paragraph({
                                            spacing: { before: 50, after: 50 },
                                            indent: { left: 100, right: 80 },
                                            alignment: AlignmentType.LEFT,

                                            children: [
                                                new TextRun({
                                                    text: url,
                                                    font: "Calibri",
                                                    size: 22,
                                                    color: "000000",
                                                    italics: false
                                                })
                                            ]
                                        })
                                    ),

                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                            ]
                        }),

                        new TableRow({
                            children: [
                                new TableCell({
                                    width: { size: 2035, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [
                                        new Paragraph({
                                            spacing: { before: 100, after: 100 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100 },
                                            children: [new TextRun({
                                                text: "Risk/Impact",
                                                font: "Calibri",
                                                size: 22,
                                                color: "ffffff",
                                                bold: true,
                                                italics: false
                                            })
                                            ]
                                        })
                                    ],
                                    shading: { type: ShadingType.SOLID, color: "003366" },
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                                new TableCell({
                                    width: { size: 8000, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        indent: { left: 100, right: 80 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.impact,
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                        ]
                                    })
                                    ],

                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                            ]
                        }),

                        new TableRow({
                            children: [
                                new TableCell({
                                    width: { size: 2035, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [
                                        new Paragraph({
                                            spacing: { before: 100, after: 100 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100 },
                                            children: [new TextRun({
                                                text: "Ease of Exploitation",
                                                font: "Calibri",
                                                size: 22,
                                                color: "ffffff",
                                                bold: true,
                                                italics: false
                                            })
                                            ]
                                        })
                                    ],
                                    shading: { type: ShadingType.SOLID, color: "003366" },
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                                new TableCell({
                                    width: { size: 8000, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.exploitation,
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                        ]
                                    })
                                    ],

                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                            ]
                        }),

                        new TableRow({
                            children: [
                                new TableCell({
                                    width: { size: 2035, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [
                                        new Paragraph({
                                            spacing: { before: 100, after: 100 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100 },
                                            children: [new TextRun({
                                                text: "CVSS String",
                                                font: "Calibri",
                                                size: 22,
                                                color: "ffffff",
                                                bold: true,
                                                italics: false
                                            })
                                            ]
                                        })
                                    ],
                                    shading: { type: ShadingType.SOLID, color: "003366" },
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                                new TableCell({
                                    width: { size: 8000, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [new Paragraph({
                                        spacing: { before: 100, after: 100 },
                                        alignment: AlignmentType.LEFT,
                                        indent: { left: 100 },
                                        children: [new TextRun({
                                            text: vulnerability.cvss,
                                            font: "Calibri",
                                            size: 22,
                                            color: "000000",
                                            italics: false
                                        })
                                        ]
                                    })
                                    ],

                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                            ]
                        }),

                        new TableRow({
                            children: [
                                // First cell: CVSS Score/ Risk Rating header
                                new TableCell({
                                    width: { size: 2035, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [
                                        new Paragraph({
                                            spacing: { before: 100, after: 100 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100 },
                                            children: [
                                                new TextRun({
                                                    text: "CVSS Score/ Risk Rating",
                                                    font: "Calibri",
                                                    size: 22,
                                                    color: "ffffff",
                                                    bold: true,
                                                    italics: false
                                                })
                                            ]
                                        })
                                    ],
                                    shading: { type: ShadingType.SOLID, color: "003366" },
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                                // Second cell: Risk score and severity
                                new TableCell({
                                    width: { size: 8000, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [
                                        new Paragraph({
                                            spacing: { before: 100, after: 100 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100 },
                                            children: [
                                                new TextRun({
                                                    text: `${riskScore} / ${severity}`,
                                                    font: "Calibri",
                                                    size: 22,
                                                    color: color,
                                                    italics: false,
                                                    bold: true
                                                })
                                            ]
                                        })
                                    ],
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                })
                            ]
                        }),

                        new TableRow({
                            children: [
                                new TableCell({
                                    width: { size: 2035, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [
                                        new Paragraph({
                                            spacing: { before: 100, after: 100 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100 },
                                            children: [new TextRun({
                                                text: "Recommendation/ Solution",
                                                font: "Calibri",
                                                size: 22,
                                                color: "ffffff",
                                                bold: true,
                                                italics: false
                                            })
                                            ]
                                        })
                                    ],
                                    shading: { type: ShadingType.SOLID, color: "003366" },
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                                new TableCell({
                                    width: { size: 8000, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    spacing: { before: 50, after: 50 },

                                    children: [
                                        new Paragraph({
                                            indent: { left: 100, right: 80 },
                                            spacing: { before: 100, after: 100 },
                                            children: [
                                                new TextRun({
                                                    text: "It is recommended to:",
                                                    font: "Calibri",
                                                    size: 22,
                                                    color: "000000",
                                                    italics: false
                                                }),
                                            ]
                                        }),
                                        ...vulnerability.recommendation.split(/•\s*/).filter(Boolean).map(bulletText =>
                                            new Paragraph({
                                                indent: { left: 700, right: 80 },
                                                spacing: { before: 100, after: 100 },
                                                bullet: { level: 0 },
                                                children: [
                                                    new TextRun({
                                                        text: bulletText.trim(),
                                                        font: "Calibri",
                                                        size: 22,
                                                        color: "000000",
                                                        italics: false
                                                    })
                                                ]
                                            })
                                        )

                                    ],

                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                            ]
                        }),

                        new TableRow({
                            children: [
                                new TableCell({
                                    width: { size: 2035, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: [
                                        new Paragraph({
                                            spacing: { before: 100, after: 100 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100 },
                                            children: [new TextRun({
                                                text: "Reference",
                                                font: "Calibri",
                                                size: 22,
                                                color: "ffffff",
                                                bold: true,
                                                italics: false
                                            })
                                            ]
                                        })
                                    ],
                                    shading: { type: ShadingType.SOLID, color: "003366" },
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                                new TableCell({
                                    width: { size: 8000, type: WidthType.DXA },
                                    verticalAlign: VerticalAlign.CENTER,
                                    children: vulnerability.reference.split(/\s+/).map((url) =>
                                        new Paragraph({
                                            spacing: { before: 100, after: 100 },
                                            alignment: AlignmentType.LEFT,
                                            indent: { left: 100, right: 80 },
                                            children: [new TextRun({
                                                text: url,
                                                font: "Calibri",
                                                size: 22,
                                                color: "000000",
                                                italics: false
                                            })
                                            ]
                                        })
                                    ),

                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "336699" },
                                    },
                                }),
                            ]
                        }),
                    ]
                }),

                new Paragraph({ pageBreakBefore: true }),
                new Paragraph({
                    spacing: { after: 200 },
                    children: [
                        new TextRun({
                            text: "Proof of Concept",
                            size: 24,
                            color: "000000",
                            font: "Calibri",
                            bold: true,
                            italics: false

                        })
                    ],
                }),

                ...combinedContent
            ]
        })
        const docSectionsResolved = await Promise.all(docSections);

        if (certInLogo) {
            try {
                const clientImageData = await getBase64(certInLogo)
                clientImageRun = new ImageRun({
                    data: clientImageData,
                    transformation: { width: 155, height: 45 }
                })
                console.log("Selected", clientImageRun);
            } catch (error) {
                console.error('Error while uploading client image:', error);
            }
        } else if (imageUrl) {
            try {
                const clientImageData = await fetchImageAsBase64(imageUrl);
                clientImageRun = new ImageRun({
                    data: clientImageData.split(',')[1],
                    transformation: { width: 155, height: 45 }
                });
            } catch (error) {
                console.error('Error while fetching client image from URL:', error);
            }
        }

        let FrontPageClientLogo;

        if (certInLogo) {
            try {
                const clientImageData = await getBase64(certInLogo)
                FrontPageClientLogo = new ImageRun({
                    transformation: { width: 220, height: 140 },
                    data: clientImageData,
                    floating: {
                        zIndex: 10,
                        horizontalPosition: { offset: 2090000 },
                        verticalPosition: { offset: 2500000 },
                    }
                })
                console.log("Selected", FrontPageClientLogo);
            } catch (error) {
                console.error('Error while uploading client image:', error);
            }
        } else if (imageUrl) {
            try {
                const clientImageData = await fetchImageAsBase64(imageUrl);
                FrontPageClientLogo = new ImageRun({
                    data: clientImageData.split(',')[1],
                    transformation: { width: 220, height: 140 },
                    floating: {
                        zIndex: 10,
                        horizontalPosition: { offset: 2090000 },
                        verticalPosition: { offset: 2500000 },
                    }
                });
            } catch (error) {
                console.error('Error while fetching client image from URL:', error);
            }
        }

        const doc = new Document({
            creator: "ISECURION",
            numbering: {
                config: [
                    {
                        reference: "my-crazy-numbering",
                        levels: [
                            {
                                level: 0,
                                format: LevelFormat.DECIMAL,
                                text: "%1.",
                                alignment: AlignmentType.RIGHT,
                                style: {
                                    paragraph: {
                                        indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                    },
                                    run: {
                                        size: 26,
                                        bold: true,
                                        color: "c00000",
                                    },
                                },
                            },
                            {
                                level: 1,
                                format: LevelFormat.DECIMAL,
                                text: "9.%2",
                                alignment: AlignmentType.RIGHT,
                                style: {
                                    paragraph: {
                                        indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                    },
                                    text: { color: "#0f0f3f", bold: true, size: 24, font: "Calibri" },
                                    run: {
                                        size: 26,
                                        bold: true,
                                        color: "c00000",
                                        font: "Cambria"
                                    },
                                },
                            },
                            {
                                level: 2,
                                format: LevelFormat.DECIMAL,
                                text: "11.%3",
                                alignment: AlignmentType.RIGHT,
                                style: {
                                    paragraph: {
                                        indent: { left: convertInchesToTwip(0.11), hanging: convertInchesToTwip(0.11) },
                                    },
                                    run: {
                                        size: 24,
                                        bold: true,
                                        color: "0f0f3f",
                                        font: "Calibri"
                                    },
                                },
                            },

                        ]
                    }
                ]
            },
            features: { updateFields: true },
            styles: {
                default: {

                    document: {
                        run: {
                            font: "Calibri",
                            bold: false,
                            size: 22,
                            color: "000000",
                        },
                    },
                    heading1: {
                        run: {
                            size: 26,
                            color: "C00000",
                            font: "Cambria",
                            bold: true,
                            italics: false,
                            allCaps: false
                        },
                        paragraph: { spacing: { line: 276 } },
                    },
                    heading2: {
                        run: {
                            size: 26,
                            color: "C00000",
                            font: "Cambria",
                            bold: true,
                            italics: false,
                            allCaps: false
                        },
                        paragraph: { spacing: { line: 276 } },
                    },
                    heading3: {
                        run: {
                            font: "Cambria",
                            size: 24,
                            bold: true,
                            color: "0f0f3f",
                            italics: false
                        },
                        paragraph: { spacing: { line: 276 } },
                    },

                },
            },
            sections: [
                {
                    properties: { page: { margin: { top: 550, right: 0, bottom: -1400, left: 0 }, size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT }, pageNumbers: { start: 0, formatType: NumberFormat.DECIMAL }, } },
                    children: [frontPage1, frontPage2, frontPage3, frontPage4,
                        new Paragraph({
                            children: [FrontPageClientLogo]
                        })]
                },
                {
                    properties: {
                        page: {
                            margin: { header: 350, footer: 700 },
                            size: { width: 12240, height: 15840, orientation: PageOrientation.PORTRAIT },
                            type: SectionType.CONTINUOUS,
                        },
                    },
                    headers: {
                        default: new Header({
                            children: [
                                new Table({
                                    margin: { top: 400 },
                                    width: { size: 110, type: WidthType.PERCENTAGE },
                                    alignment: AlignmentType.LEFT,
                                    borders: {
                                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" }
                                    },
                                    rows: [
                                        new TableRow({
                                            children: [
                                                new TableCell({
                                                    width: { size: 50, type: WidthType.PERCENTAGE },
                                                    children: [
                                                        new Paragraph({ indent: { right: 400 }, alignment: AlignmentType.LEFT, children: [footerIsecurion] })],
                                                    borders: {
                                                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    },
                                                }),

                                                new TableCell({
                                                    width: { size: 50, type: WidthType.PERCENTAGE },
                                                    children: [
                                                        new Paragraph({ indent: { right: 400 }, alignment: AlignmentType.RIGHT, children: [clientImageRun] })],
                                                    borders: {
                                                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    },
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    },
                    footers: {
                        default: new Footer({
                            children: [
                                new Table({
                                    margin: { top: 600 },
                                    width: { size: 100, type: WidthType.PERCENTAGE },
                                    borders: {
                                        top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                    },
                                    rows: [
                                        new TableRow({
                                            children: [

                                                new TableCell({
                                                    width: { size: 65, type: WidthType.PERCENTAGE },
                                                    children: [
                                                        new Paragraph({
                                                            indent: { right: 200 },
                                                            alignment: AlignmentType.LEFT,
                                                            children: [
                                                                new TextRun({
                                                                    text: "Confidential 2026",
                                                                    font: "Calibri",
                                                                    size: 22,
                                                                    italics: false,
                                                                }),
                                                            ],
                                                        }),
                                                    ],
                                                    borders: {
                                                        top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    },
                                                }),
                                                new TableCell({
                                                    width: { size: 32, type: WidthType.PERCENTAGE },
                                                    children: [
                                                        new Paragraph({
                                                            alignment: AlignmentType.RIGHT,
                                                            children: [
                                                                new TextRun({
                                                                    text: "Page",
                                                                    italics: false,
                                                                    font: "Calibri",
                                                                    size: 22,
                                                                    bold: true,
                                                                }),
                                                            ],
                                                        }),
                                                    ],
                                                    borders: {
                                                        top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    },
                                                }),
                                                new TableCell({
                                                    width: { size: 3, type: WidthType.PERCENTAGE },
                                                    children: [
                                                        new Paragraph({
                                                            alignment: AlignmentType.RIGHT,
                                                            children: [
                                                                new TextRun({
                                                                    children: [PageNumber.CURRENT],
                                                                    italics: false,
                                                                    font: "Calibri",
                                                                    size: 22,
                                                                    bold: true,
                                                                }),
                                                            ],
                                                        }),
                                                    ],
                                                    borders: {
                                                        top: { style: BorderStyle.THIN_THICK_MEDIUM_GAP, size: 3 * 8, color: "632423" },
                                                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                                    },
                                                }),
                                            ],
                                        }),
                                    ],
                                }),
                            ],
                        }),
                    },
                    children: [page11c, page12c, page13c, page14c],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [page11, page12, page13, page14],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [page21, page22, page23, page24],
                    pageBreakBefore: true,
                },


                {
                    properties: { ...design },
                    children: [
                        page31,
                        new Table({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            layout: TableLayoutType.FIXED,
                            borders: {
                                top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                                right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                            },
                            alignment: AlignmentType.LEFT,
                            // indent: { size: 500, type: WidthType.DXA },
                            rows: [
                                new TableRow({

                                    children: [
                                        new TableCell({
                                            width: { size: 100, type: WidthType.PERCENTAGE },
                                            children: [
                                                new Paragraph({
                                                    children: [
                                                        new TableOfContents("Table of Content", {
                                                            hyperlink: true,
                                                            headingStyleRange: "1-5",
                                                        }),
                                                    ],
                                                }),
                                            ],
                                        }),
                                    ],
                                }),
                            ],
                        }),
                    ],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [page41, page42, page43, page44, page45, page451, page452, page453, page454, page455, page456],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [page51, page52, page53, page54, page55, page56],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [page61, page611, page62, page621, page622, page623, page624, page63, page631, page64],
                    pageBreakBefore: true,
                },

                {
                    properties: { ...design },
                    children: [page71, page711, page712, page72,
                        new Paragraph({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            spacing: { line: 276, before: 250, after: 300 },
                            alignment: AlignmentType.JUSTIFIED,
                            children: [
                                new TextRun({
                                    text: "Testing was performed on the" + ' ' + certInAppEnvironment + ' ' + "Environment." + ' ' + certInTestingype + ' ' + (certInTestingype === "Black box testing methodology (Unauthenticated Testing)" ? "was performed." : "was performed with below-mentioned user role:"),
                                    size: 22,
                                    font: "Calibri",
                                    color: '000000',
                                    italics: false
                                }),
                            ],
                        }),
                        page722, page73, page731, page732],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [page81, page811, page82, page821, page822, page823, page824, page83, page831],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [page91, page911, page92, page921, page93, page931],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [page101, page102, page1021, page103, page1031, page104, page1041, page1042, page1043, page1044, page1045, page1046, page1047, page1048, page1049, page10410],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [page111, page112, page113, page114],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [page115, page116],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [page121, page1211, page1212, cvssMapping, page1213],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [page122, page1221, easeOfExploitation, page1222],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [page123, page1231, page1232, page1241],
                    pageBreakBefore: true,
                },

                {
                    properties: { ...design },
                    children: [page131, page1312,
                        new Table({
                            width: { size: 100, type: WidthType.PERCENTAGE },
                            alignment: AlignmentType.CENTER,
                            spacing: { before: 1200 },
                            borders: {
                                top: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                bottom: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                left: { style: BorderStyle.SINGLE, size: 1, color: "000000" },
                                right: { style: BorderStyle.SINGLE, size: 1, color: "000000" }
                            },
                            rows: rows
                        })
                    ],
                    pageBreakBefore: true,
                },

                {
                    properties: { ...design },
                    children: [page141, page1411, page1412, page1413],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [
                        ...docSectionsResolved.flat()
                    ],
                    pageBreakBefore: true,
                },

                {
                    properties: { ...design },
                    children: [page161, page162],
                    pageBreakBefore: true,
                },
                {
                    properties: { ...design },
                    children: [page171, page1711, page1712, page1713, page1714, page1715, page1716, page1717, page1718, page1719, page17110, page17111],
                    pageBreakBefore: true,
                },
            ]
        })
        Packer.toBlob(doc).then(blob => {
            saveAs(blob, `Security Audit Phase 1 Report of ${certInApplicationName} Web Application v1.0.docx`);
        });
    }

    return (
        <div>
            <CertInHTMLReport
                handleCertInDownload={handleCertInDownload}
                certInReportName={certInReportName}
                setCertInReportName={setCertInReportName}
                certInDate={certInDate}
                setCertInDate={setCertInDate}
                certInCustomerName={certInCustomerName}
                setCertInCustomerName={setCertInCustomerName}
                certInLogo={certInLogo}
                setCertInLogo={setCertInLogo}
                imageUrl={imageUrl}
                setImageUrl={setImageUrl}
                certInApplicationName={certInApplicationName}
                setCertInApplicationName={setCertInApplicationName}
                certInApplicationUrl={certInApplicationUrl}
                setCertInApplicationUrl={setCertInApplicationUrl}
                certInStartDate={certInStartDate}
                setCertInStartDate={setCertInStartDate}
                certInEndDate={certInEndDate}
                setCertInEndDate={setCertInEndDate}
                certInTestingype={certInTestingype}
                setCertInTestingType={setCertInTestingType}
                certInAppDescription={certInAppDescription}
                setCertInAppDescription={setCertInAppDescription}
                certInAppEnvironment={certInAppEnvironment}
                setCertInAppEnvironment={setCertInAppEnvironment}
                certInRoles={certInRoles}
                setCertInRoles={setCertInRoles}
                criticality={criticality}
                setCriticality={setCriticality}

                inchargeDesignation={inchargeDesignation}
                inchargeEmail={inchargeEmail}
                inchargeName={inchargeName}
                setInchargeDesignation={setInchargeDesignation}
                setInchargeEmail={setInchargeEmail}
                setInchargeName={setInchargeName}
                certInVulCount={certInVulCount}
                setCertInVulCount={setCertInVulCount}
                certInCritical={certInCritical}
                setCertInCritical={setCertInCritical}
                certInHigh={certInHigh}
                setCertInHigh={setCertInHigh}
                certInMedium={certInMedium}
                setCertInMedium={setCertInMedium}
                certInLow={certInLow}
                setCertInLow={setCertInLow}
                certInInfo={certInInfo}
                setCertInInfo={setCertInInfo}
                certInA1={certInA1}
                setCertInA1={setCertInA1}
                certInA2={certInA2}
                setCertInA2={setCertInA2}
                certInA3={certInA3}
                setCertInA3={setCertInA3}
                certInA4={certInA4}
                setCertInA4={setCertInA4}
                certInA5={certInA5}
                setCertInA5={setCertInA5}
                certInA6={certInA6}
                setCertInA6={setCertInA6}
                certInA7={certInA7}
                setCertInA7={setCertInA7}
                certInA8={certInA8}
                setCertInA8={setCertInA8}
                certInA9={certInA9}
                setCertInA9={setCertInA9}
                certInA10={certInA10}
                setCertInA10={setCertInA10}
                certInVulnerabilities={certInVulnerabilities}
                setCertInVulnerabilities={setCertInVulnerabilities}

                certInReportNameError={certInReportNameError}
                setCertInReportNameError={setCertInReportNameError}
                certInDateError={certInDateError}
                setCertInDateError={setCertInDateError}
                certInCustomerNameError={certInCustomerNameError}
                setCertInCustomerNameError={setCertInCustomerNameError}
                certInLogoError={certInLogoError}
                setCertInLogoError={setCertInLogoError}
                certInApplicationNameError={certInApplicationNameError}
                setCertInApplicationNameError={setCertInApplicationNameError}
                certInApplicationUrlError={certInApplicationUrlError}
                setCertInApplicationUrlError={setCertInApplicationUrlError}
                certInStartDateError={certInStartDateError}
                setCertInStartDateError={setCertInStartDateError}
                certInEndDateError={certInEndDateError}
                setCertInEndDateError={setCertInEndDateError}
                certInTestingypeError={certInTestingypeError}
                setCertInTestingTypeError={setCertInTestingTypeError}
                certInAppDescriptionError={certInAppDescriptionError}
                setCertInAppDescriptionError={setCertInAppDescriptionError}
                certInAppEnvironmentError={certInAppEnvironmentError}
                setCertInAppEnvironmentError={setCertInAppEnvironmentError}
                certInRolesError={certInRolesError}
                setCertInRolesError={setCertInRolesError}
                certInDownloading={certInDownloading}
                setCertInDownloading={setCertInDownloading}
            />
        </div>
    )
}

export default CertInReport
